// import Image from "next/image";
import { Img } from "react-image";
import {
  FocusEventHandler,
  ForwardRefRenderFunction,
  InputHTMLAttributes,
  MouseEventHandler,
  forwardRef,
  useState,
} from "react";

// import { Spinner } from "@/components/Spinner";
// import { cx } from "@/ui/helpers";
import { cx } from "../../../helpers";

import styles from "./styles.module.css";
import { Spinner } from "../Spinner";
import assetPath from "../../../utils/assets";

export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "size"> & {
  loading?: boolean;
  iconLeft?: React.ReactNode;
  size?: "sm" | "md";
  hasError?: boolean;
  label?: string;
  labelClassName?: string;
  containerClassName?: string;
  mapPinIcon?: boolean;
  passwordToggle?: boolean; // New prop to enable password toggle feature
};
const imgMapPin = assetPath('map-pin.svg');
const imgEyeIcon = assetPath('eye-icon.svg');
const imgEyeClosedIcon = assetPath('eye-closed-icon.svg');
const InputComponent: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  props,
  ref,
) => {
  const {
    className,
    iconLeft,
    size,
    required,
    loading,
    hasError,
    placeholder,
    containerClassName,
    label,
    labelClassName,
    mapPinIcon,
    passwordToggle,
    type,
    ...rest
  } = props;
  const sizeStyles = styles[`input-${size || "md"}`];

  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [inputType, setInputType] = useState(type || "text");

  const handleMouseOver = () => setIsHovered(true);
  const handleMouseOut = () => setIsHovered(false);
  const handleFocus: FocusEventHandler<HTMLInputElement> = e => {
    rest.onFocus?.(e);
    setIsFocused(true);
  };
  const handleBlur: FocusEventHandler<HTMLInputElement> = e => {
    rest.onBlur?.(e);
    setIsFocused(false);
  };

  const togglePasswordVisibility: MouseEventHandler<HTMLDivElement> = e => {
    e.stopPropagation();
    setInputType(prevType => (prevType === "password" ? "text" : "password"));
  };

  return (
    <div
      className={cx(
        styles.inputContainer,
        isHovered && styles.hover,
        isFocused && styles.focus,
        hasError && styles.error,
        containerClassName,
      )}
    >
      {loading && (
        <div className={styles.spinnerContainer}>
          <Spinner className={styles.spinner} />
        </div>
      )}

      {mapPinIcon && (
        <Img
          src={imgMapPin}
          width={16}
          height={16}
          alt="address pin"
          className={styles.mapPinIcon}
        />
      )}

      {iconLeft}
      <label htmlFor={label} className={labelClassName}>
        {label}
      </label>
      <input
        ref={ref}
        id={label}
        disabled={loading || rest.disabled}
        className={cx("twp",styles.input, sizeStyles, className)}
        placeholder={
          label ? placeholder : required ? `${placeholder}*` : placeholder
        }
        {...rest}
        type={inputType}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {passwordToggle && (
        <div
          className={styles.eyeIconContainer}
          onClick={togglePasswordVisibility}
        >
          <Img
                      src={
              inputType === "text"
                ? imgEyeIcon
                : imgEyeClosedIcon
            }
            width={16}
            height={16}
            alt="toggle password visibility"
            className={styles.eyeIcon}
          />
        </div>
      )}
    </div>
  );
};

export const Input = forwardRef<HTMLInputElement, InputProps>(InputComponent);
